// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12shK","newExpiryDate":"styles_newExpiryDate__2Sius","footer":"styles_footer__3Fh4c"};